import { Component, Input, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { EventsService, UtilService, VariablesService } from 'src/app/shared/services';
import { SharedModule } from 'src/app/shared/shared.module';
import { IFundraiser } from 'src/app/fundraiser/models/fundraiser.model';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'app-fundraiser-random-card',
    standalone: true,
    imports: [CommonModule, MatButtonModule, SharedModule],
    templateUrl: './fundraiser-random-card.component.html',
    styleUrls: ['./fundraiser-random-card.component.scss']
})

export class FundraiserRandomCardComponent {
    @Input() theme;
    @Input() fundraisers: IFundraiser[];
    dialogRef: MatDialogRef<any>;
    @ViewChild('randomFundariserAnimation', { static: true }) randomFundariserAnimation;
    private userData;
    private pickNextRandom: any;
    showBlurModal: boolean = false;
    isMobile: boolean = false;
    isSafari: boolean = false;
    constructor(
        private events: EventsService,
        public util: UtilService,
        private vars: VariablesService,
        private dialog: MatDialog,
    ) { }

    ngOnInit(): void {
        this.isSafari = this.util.detectBrowser() === 'Safari' ? true : false;
        this.pickNextRandom = this.createUniquePicker(this.fundraisers);        //create a random picker closure in one go
        this.vars.userData.subscribe(res => {
            this.userData = res;
        });
        this.isMobile = this.util.isMobile();
    }

    openPopup() {
        this.showBlurModal = false;
        this.dialogRef = this.dialog.open(this.randomFundariserAnimation, {
            width: this.isMobile ? '100vw' : '528px',
            panelClass: 'random-fundraiser-animation-dialog'
        });
        setTimeout(()=>{
            this.dialogRef?.close();
        }, 3000);
        this.dialogRef.afterClosed().subscribe(val => {
            this.vars.showRandomBanner = true;
            this.goToRandomFundraiser()
        });
    }

    /**
     * Returns a function that, on each call, pulls out a random item
     * from `fundraisers` without replacement. Once empty, returns null.
     */
    createUniquePicker<T>(fundraisers: T[]): () => T | null {
        // make a mutable copy
        let pool = [...fundraisers];
        return () => {
            if (pool.length === 0) {
                pool = [...fundraisers];         //return null for Unique Random Fundraiser Only or: pool = [...items] to reshuffle
            }
            const idx = Math.floor(Math.random() * pool.length);
            // remove & return that element
            return pool.splice(idx, 1)[0];
        };
    }

    goToRandomFundraiser() {
        const fundraiser = this.pickNextRandom();
        let eventName = 'random_picker_card_clicked';
        const donorNonDonor = this.userData?.aggdonationall?.funds > 0 ? 'donor' : 'non_donor';
        this.events.sendSystemEvent({
            eventName: eventName,
            info_1: donorNonDonor || '',
            info_2: fundraiser?.id
        }).subscribe(_ => _);
        if(!this.isSafari){
            const redirectionRoutePrefix = (fundraiser?.page_name === 'stories') ? '/stories/' : '/fundraiser/';
            const donatePopup = '?randomcampaign=1';
            this.util.nativeNavigation(`${redirectionRoutePrefix}${fundraiser?.custom_tag}${donatePopup}`, true);
        } else if(this.isSafari) {
            const path = `${fundraiser.page_name === 'stories' ? '/stories/' : '/fundraiser/'}${fundraiser.custom_tag}`;
            const queryParams = { randomcampaign: '1' };
            this.util.router.navigate([path], { queryParams });
        }
    }
}